export enum ServiceProviderType {
    analyst = 'analyst',
    biometrician = 'biometrician',
    biometricianAndGrader = 'biometricianAndGrader',
    grader = 'grader',
}
